import { render, staticRenderFns } from "./tree-menu.vue?vue&type=template&id=ce0567b0&scoped=true"
import script from "./tree-menu.vue?vue&type=script&lang=js"
export * from "./tree-menu.vue?vue&type=script&lang=js"
import style0 from "./tree-menu.vue?vue&type=style&index=0&id=ce0567b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0567b0",
  null
  
)

export default component.exports